// This redux state is for the application state such as error/issues.
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";

// Enable Map and Set support for Immer
enableMapSet();

interface schema {
  outOfRange: string[];
}

const initialState: schema = {
  outOfRange: [],
};

const yieldsheetSlice = createSlice({
  name: "yieldsheet",
  initialState,
  reducers: {
    addOutOfRange: (state, action: PayloadAction<string>) => {
      if (!state.outOfRange.includes(action.payload)) {
        state.outOfRange.push(action.payload);
      }
    },
    removeOutOfRange: (state, action: PayloadAction<string>) => {
      state.outOfRange = state.outOfRange.filter((id) => id !== action.payload);
    },
    resetYieldsheet: () => initialState,
  },
});

export const { resetYieldsheet, addOutOfRange, removeOutOfRange } =
  yieldsheetSlice.actions;

export const selectYieldsheet = (state: { yieldsheet: schema }) =>
  state.yieldsheet;

export default yieldsheetSlice.reducer;
